import type { ManagedEntitiesApiTyped } from './types';

import './setup';
import { managedEntitiesApiRoot } from './root';

export const managedEntities =
  managedEntitiesApiRoot as ManagedEntitiesApiTyped;
